import { FC } from "react"

import { ReactComponent as IconCoin } from "@brand_assets/svg/coin.svg"
import { Box, Typography } from "@mui/material"
import { Trans, useTranslation } from "react-i18next"
import { showDecimal } from "utils/decimalNumber"

interface IProps {
  lineCount: number
  studentCount: number
  costPerStudent: number
}

const CartSummary: FC<IProps> = ({
  lineCount,
  studentCount,
  costPerStudent,
}) => {
  const { t } = useTranslation()

  return (
    <Typography
      variant="body1"
      color="mockup.neutral20"
      flex={1}
      minWidth="200px"
      aria-live="polite"
      aria-atomic="true"
    >
      {[
        t("storeCharge.select.summaryItems", { count: lineCount }),
        t("storeCharge.select.summaryStudents", { count: studentCount }),
        "",
      ].join(" · ")}
      <Trans
        i18nKey="storeCharge.select.summaryEach"
        values={{ amount: showDecimal(costPerStudent) }}
        components={{
          coin: (
            <Box
              component="span"
              aria-hidden
              sx={{
                display: "inline-block",
                verticalAlign: "-0.125em",
                mr: 0.5,
                "& svg": {
                  display: "block",
                  width: "1em",
                  height: "1em",
                },
              }}
            >
              <IconCoin />
            </Box>
          ),
        }}
      />
    </Typography>
  )
}

export default CartSummary
